import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import ScaleContinuous, { deInterpolateLinear, copyScale } from './continuous';
import interpolateNumber from '../utils/interpolators/number';

var ScaleCategory =
/*#__PURE__*/
function (_ScaleContinuous) {
  _inherits(ScaleCategory, _ScaleContinuous);

  function ScaleCategory() {
    _classCallCheck(this, ScaleCategory);

    return _possibleConstructorReturn(this, _getPrototypeOf(ScaleCategory).call(this, deInterpolateLinear, interpolateNumber));
  }

  _createClass(ScaleCategory, [{
    key: "copy",
    value: function copy() {
      return copyScale(this, new ScaleCategory());
    }
  }]);

  return ScaleCategory;
}(ScaleContinuous);

export default ScaleCategory;